
import draggable from '../draggable';

export default {
  name: 'EleSvPanel',
  emits: ['change'],
  props: {
    // 色相
    hue: {
      type: Number,
      required: true
    },
    // 饱和度
    saturation: {
      type: Number,
      required: true
    },
    // 明度
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      // 滑块位置top
      cursorTop: 0,
      // 滑块位置left
      cursorLeft: 0,
      // 色板背景色
      background: 'hsl(0, 100%, 50%)'
    };
  },
  mounted() {
    // 获取滑块的默认位置和色板的默认背景
    this.background = this.getBackground();
    this.cursorLeft = this.getCursorLeft();
    this.cursorTop = this.getCursorTop();
    // 色板绑定鼠标移动事件
    draggable(this.$el, {
      drag: (event) => {
        this.handleDrag(event);
      },
      end: (event) => {
        this.handleDrag(event);
      }
    });
  },
  methods: {
    /* 选中改变事件 */
    handleDrag(event) {
      const el = this.$el,
        rect = el.getBoundingClientRect();
      let left = event.clientX - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);
      let top = event.clientY - rect.top;
      top = Math.max(0, top);
      top = Math.min(top, rect.height);
      this.cursorLeft = left;
      this.cursorTop = top;
      this.$emit('change', {
        saturation: left / rect.width * 100,
        value: 100 - top / rect.height * 100
      });
    },
    /* 计算滑块位置top */
    getCursorTop() {
      let {clientHeight: height} = this.$el;
      return (100 - this.value) * height / 100;
    },
    /* 计算滑块位置left */
    getCursorLeft() {
      let {clientWidth: width} = this.$el;
      return this.saturation * width / 100;
    },
    /* 获取色板背景 */
    getBackground() {
      return 'hsl(' + this.hue + ', 100%, 50%)';
    }
  },
  watch: {
    hue() {
      this.background = this.getBackground();
    },
    saturation() {
      this.cursorLeft = this.getCursorLeft();
    },
    value() {
      this.cursorTop = this.getCursorTop();
    }
  }
};
